// extracted by mini-css-extract-plugin
export default {"current":"SortableList_current__j+Xh+","sortable_list":"SortableList_sortable_list__rvxPx","sortable-grid":"SortableList_sortable-grid__zeCji"};